<template>
  <v-app-bar app clipped-left dark id="header-app">
    <v-app-bar-nav-icon
      @click.stop="toggleDesktopMenu()"
      class="hidden-sm-and-down"
    />

    <v-app-bar-nav-icon
      @click.stop="enableSmartphoneMenu()"
      class="hidden-md-and-up"
    ></v-app-bar-nav-icon>

    <v-toolbar-title>{{ title }}</v-toolbar-title>

    <v-spacer></v-spacer>
    <div v-if="!isSmartphoneMenu">
      <v-btn v-if="!isAuthenticated" @click="login" text>Connexion</v-btn>
    </div>
    <BaseUser v-if="isAuthenticated" />
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import BaseUser from "@/components/base/BaseUser";

export default {
  name: "BaseHeader",
  components: { BaseUser },
  props: { displayMenu: Boolean, isSmartphoneMenu: Boolean },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      // URL de connexion
      loginUrl:
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_LOGIN
    };
  },
  computed: {
    ...mapState(["isAuthenticated"])
  },
  methods: {
    // action login => envoie vers l'identification CAS via le backend de l'application
    login() {
      window.location = this.loginUrl;
    },
    toggleDesktopMenu() {
      this.$emit("update:isSmartphoneMenu", false);
      if (this.displayMenu == null) {
        this.$emit("update:displayMenu", false);
      } else {
        this.$emit("update:displayMenu", !this.displayMenu);
      }
    },

    enableSmartphoneMenu() {
      this.$emit("update:isSmartphoneMenu", true);
      this.$emit("update:displayMenu", true);
    }
  }
};
</script>

<style scoped>
.v-application.theme--light header#header-app {
  background-color: #1f8388;
  z-index: 20;
}

.unswitch {
  background-color: #e22 !important;
}
</style>
